import React from 'react';

interface BooleanInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const BooleanInput: React.FC<BooleanInputProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  return (
    <label className="flex items-center space-x-3 cursor-pointer">
      <input
        type="checkbox"
        checked={value || false}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="w-4 h-4 text-brand bg-elevated border-subtle rounded focus:ring-brand focus:ring-2"
      />
      <span className="text-th-primary">Yes</span>
    </label>
  );
};